export default "__VITE_PUBLIC_ASSET__2a39f9ef__"